import {
  HTTP_SELBRAND_FETCHING,
  HTTP_SELBRAND_SUCCESS,
  HTTP_SELBRAND_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_SELBRAND_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_SELBRAND_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_SELBRAND_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };
    default:
      return state;
  }
};
